import React, { useMemo } from "react";

import { isArray } from "lodash";
import { useDealUserRoleSelect } from "store";
import { CustomComponent, IRoleName } from "store/types";

interface Props {
  availableRoles: IRoleName | IRoleName[];
  children: React.ReactNode;
  hideChild?: boolean;
  RenderInstead?: JSX.Element | CustomComponent;
}

export const ClientRoleGuard: React.FC<Props> = ({ availableRoles, children, hideChild, RenderInstead }) => {
  const role = useDealUserRoleSelect();

  return useMemo(() => {
    if (hideChild) {
      return RenderInstead && typeof RenderInstead !== "function" ? RenderInstead : <></>;
    }
    // Users aren't limited if there is no deal_role
    if (!role) return children;

    if (typeof availableRoles === "string" && role === availableRoles) {
      return children;
    }

    if (role && isArray(availableRoles) && availableRoles.includes(role)) {
      return children;
    }

    if (RenderInstead && typeof RenderInstead === "function") {
      return <RenderInstead />;
    }

    if (RenderInstead && typeof RenderInstead !== "function") {
      return RenderInstead;
    }

    return null;
  }, [role, availableRoles, children, hideChild, RenderInstead]);
};
